import { useMemo } from 'react';
import QRCode from 'qrcode';

/**
 * QR code drawn as inline SVG from the encoder's module matrix: no image URL (the portal CSP
 * allows img-src 'self' only) and nothing leaves the browser. The value is held only in memory.
 */
export function QrCode({ value, size = 208, label }: { value: string; size?: number; label: string }) {
  const { path, dim } = useMemo(() => {
    const qr = QRCode.create(value, { errorCorrectionLevel: 'M' });
    const n = qr.modules.size;
    const quiet = 4;
    let d = '';
    for (let r = 0; r < n; r++) {
      for (let c = 0; c < n; c++) {
        if (qr.modules.get(r, c)) d += `M${c + quiet} ${r + quiet}h1v1h-1z`;
      }
    }
    return { path: d, dim: n + quiet * 2 };
  }, [value]);
  return (
    <svg role="img" aria-label={label} width={size} height={size} viewBox={`0 0 ${dim} ${dim}`} shapeRendering="crispEdges"
      className="rounded-md">
      <rect width={dim} height={dim} fill="#ffffff" />
      <path d={path} fill="#000000" />
    </svg>
  );
}
